// @ts-strict-ignore
// It's important that this remains here as SWC is set to mode entry in Remix
// This is because usage doesn't work properly
// It's a workaround that ensures polyfills are applied for newer features that aren't present in all browsers we support
import "core-js";
import { CacheProvider } from "@emotion/react";
import { RemixBrowser } from "@remix-run/react";
import { StrictMode, useState } from "react";
import { hydrateRoot } from "react-dom/client";

import { ApolloClientProvider } from "@remix/components/ApolloClientProvider/ApolloClientProvider";
import { decodeFromMetaTag } from "@remix/helpers/decodeFromMetaTag/decodeFromMetaTag.client";
import { LoadingProvider } from "@shared/components/LoadingProvider/LoadingProvider";
import { InitialPropsProvider } from "@shared/context/InitialPropsProvider";

import { ClientStyleContext } from "./context/ClientStyleContext";
import { clientInitCoralogix } from "./helpers/clientInitCoralogix/clientInitCoralogix.client";
import { clientInitSentry } from "./helpers/clientInitSentry/clientInitSentry";
import { createEmotionCache } from "./helpers/createEmotionCache/createEmotionCache";

const INITIAL_PROPS = JSON.parse(decodeFromMetaTag("initial-props"));

window.deviceType = decodeFromMetaTag("device-type");

// Initialize Sentry error reporting
clientInitSentry(INITIAL_PROPS.flippers.includes("sentry_tunnel"));
clientInitCoralogix();

const Client = () => {
  const [cache, setCache] = useState(createEmotionCache());

  const reset = () => {
    setCache(createEmotionCache());
  };

  return (
    <StrictMode>
      <InitialPropsProvider initialProps={INITIAL_PROPS}>
        <LoadingProvider>
          <ApolloClientProvider>
            <ClientStyleContext value={{ reset }}>
              <CacheProvider value={cache}>
                <RemixBrowser />
              </CacheProvider>
            </ClientStyleContext>
          </ApolloClientProvider>
        </LoadingProvider>
      </InitialPropsProvider>
    </StrictMode>
  );
};

hydrateRoot(document, <Client />);
